export type CapaStatus =
  "UNDER_REVIEW" | "ACTION_IN_PROGRESS" | "EFFECTIVENESS_REVIEW" | "CLOSED";

export type CapaRecord = {
  id: string;
  capaNo: string;
  title: string;
  description: string;
  sourceType:
    | "SUPPLIER"
    | "GOODS_RECEIPT"
    | "PRODUCTION"
    | "CUSTOMER_COMPLAINT"
    | "INTERNAL_AUDIT"
    | "MAINTENANCE";
  severity: "LOW" | "MEDIUM" | "HIGH" | "CRITICAL";
  status: CapaStatus;
  supplierReference: string | null;
  purchaseOrderReference: string | null;
  materialReference: string | null;
  lotReference: string | null;
  containmentAction: string | null;
  rootCause: string | null;
  actionPlan: string | null;
  actionOwnerName: string | null;
  dueAt: string | null;
  completionNote: string | null;
  evidenceReference: string | null;
  effectivenessResult: "EFFECTIVE" | "INEFFECTIVE" | null;
  effectivenessNote: string | null;
  createdByName: string;
  createdAt: string;
  updatedAt: string;
  closedAt: string | null;
  history: Array<{
    id: string;
    action: string;
    actorName: string;
    actorRole: string;
    note: string | null;
    occurredAt: string;
  }>;
};

export const capaStatusLabels: Record<CapaStatus, string> = {
  UNDER_REVIEW: "Kalite değerlendirmesinde",
  ACTION_IN_PROGRESS: "Faaliyet yürütülüyor",
  EFFECTIVENESS_REVIEW: "Etkinlik kontrolünde",
  CLOSED: "Kapatıldı",
};

export const capaSourceLabels: Record<CapaRecord["sourceType"], string> = {
  SUPPLIER: "Tedarikçi uygunsuzluğu",
  GOODS_RECEIPT: "Mal kabul uygunsuzluğu",
  PRODUCTION: "Üretim uygunsuzluğu",
  CUSTOMER_COMPLAINT: "Müşteri şikâyeti",
  INTERNAL_AUDIT: "İç denetim",
  MAINTENANCE: "Bakım",
};
